module.exports = __webpack_public_path__ + "static/media/gr_background.ceec7531.png";